export const ITEMS_PER_PAGE = 20;
export const ASC = 'asc';
export const DESC = 'desc';
export const SORT = 'sort';
